import Vue from 'vue';

Vue.mixin({
  methods: {
    deepEqual(object1, object2) {
      const keys1 = Object.keys(object1);
      const keys2 = Object.keys(object2);
      const self: any = this;

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (const key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];
        const areObjects = self.isObject(val1) && self.isObject(val2);
        if ((areObjects && !self.deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
          return false;
        }
      }

      return true;
    },
    isObject(object) {
      return object != null && typeof object === 'object';
    },
  },
});
